import { MedicalInformationPractitioner } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledMargin,
   TestableComponentProps,
   Tooltip,
   TooltipLabel,
   TooltipPlacement,
} from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

type PractitionerTooltipQuestionIconProps = {
   readonly practitioner: MedicalInformationPractitioner;
   readonly label: TranslatableText;
} & TestableComponentProps;

export const PractitionerTooltipQuestionIcon = (props: PractitionerTooltipQuestionIconProps): JSX.Element => {
   return (
      <Tooltip
         testId={props.testId}
         maxWidth={'400px'}
         placement={TooltipPlacement.TOP}
         content={
            <div>
               <TooltipLabel label={props.label} />
               <PractitionerSafePresenter
                  practitioner={props.practitioner}
                  testId={'practitioner'}
                  type={'text'}
                  withIdentification
               />
            </div>
         }
      >
         <StyledMargin top={-2}>
            <IconWrapper testId={'usingDefaultConfiguration'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALL}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </StyledMargin>
      </Tooltip>
   );
};
